// Distribution Partner is free text typed by humans in the Information tab, so
// the same partner turns up as "Breu AG", "Breu Ag" and "Breu  AG". Both the
// ticket list and the installation flat list offer it as a filter and must fold
// those spellings identically, otherwise picking a partner in one place returns
// a different set than picking it in the other. Hence one implementation here
// rather than a copy per call site.

// Fold a partner name for matching: trim, collapse inner runs of whitespace,
// lowercase. Never shown to the user — use the display label from
// partnerOptions for that.
export function normalizePartner(p: string | null | undefined): string {
  return (p ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
}

// One canonical, display-ready label per distinct partner, alphabetically
// sorted. Blank names are dropped; callers that want an explicit "Not set"
// entry add it themselves. Where spellings differ only by case or spacing the
// alphabetically first one wins, so the label is stable across renders.
export function partnerOptions(names: (string | null | undefined)[]): string[] {
  const canonical = names.reduce((map, p) => {
    if (!p || p.trim() === '') return map;
    const display = p.trim().replace(/\s+/g, ' ');
    const key = normalizePartner(p);
    const current = map.get(key);
    if (!current || display.localeCompare(current) < 0) map.set(key, display);
    return map;
  }, new Map<string, string>());

  return Array.from(canonical.values()).sort((a, b) => a.localeCompare(b));
}
